import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Accept, Cancel } from 'Common/Components/Button/styled';
import useModalShortcuts from 'Hooks/useModalShortcuts';
import { MODAL_WORKSPACE_UPDATE_NAME } from 'store/modals/modals';
import { closeModal } from 'store/modals/actions';
import { useIntl } from 'react-intl';
import ButtonsContainer from 'Screens/Contextualization/Host/components/HostVulnerabilities/VulnsTable/BulkUpdateModal/components/SubmitButtons/styled';
import { selectUpdateField, selectUpdateValue, selectWsDetail } from 'store/Workspace/selectors';
import { updateWS } from 'Screens/Contextualization/Workspaces/actions/Actions';
import { get } from 'lodash';

const Buttons = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const workspaceDetail = useSelector(selectWsDetail);
  const currentName = get(workspaceDetail, 'name', '');

  const cancelLabel = intl.formatMessage({ id: 'common.components.button.cancel' });
  const saveLabel = intl.formatMessage({ id: 'common.components.button.save' });

  const updateField = useSelector(selectUpdateField);
  const updateValue = useSelector(selectUpdateValue);

  const handleClose = () => dispatch(closeModal(MODAL_WORKSPACE_UPDATE_NAME));

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(updateWS(currentName, { name: updateValue }));
    handleClose();
  };

  const canSave = !(updateField === 'name' && !updateValue);

  useModalShortcuts({ id: 'workspace-rename', onSave: handleSubmit, onCancel: handleClose, canSave });

  return (
    <ButtonsContainer>
      <Cancel onClick={ handleClose } children={ cancelLabel } />
      <Accept onClick={ handleSubmit } children={ saveLabel } disabled={ updateField === 'name' && !updateValue } />
    </ButtonsContainer>

  );
};

export default Buttons;
